<template>
    <div class="header">
        <div class="header-title">
            <p>{{ routerTitle }}</p>
        </div>
        <div
            v-if="routerKey == 0 || routerKey == 1 || routerKey == 2||routerKey == 6||routerKey == 7 ||routerKey == 8||routerKey == 9"
            class="header-content"
        >
            <div class="content-right">
                <p style="width:45px;margin-right: 10px;">年度：</p>
                <a-select
                    v-model="selectYearValue"
                    placeholder="请选择"
                    style="width: 200px"
                    @change="handleChange"
                >
                    <a-select-option
                        v-for="(item, i) in yearList"
                        :key="i"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </a-select-option>
                </a-select>
                <!-- 省级意见 -->
                <p v-if="routerKey ==6 "
                   style=" width: 70px;; margin-left:20px;margin-right: 10px;">
                    省级意见:
                </p>
                <a-select
                    v-if="routerKey ==6 "
                    v-model="selectProvinceOpinion"
                    placeholder="请选择"
                    style="width: 200px"
                    @change="handleOpinionChange"
                >
                    <a-select-option
                        v-for="(item, i) in projectList"
                        :key="i"
                        :value="item.value"
                    >
                        {{ item.name }}
                    </a-select-option>
                </a-select>
                <a-input v-if="routerKey == 6||routerKey == 7||routerKey == 8" v-model="keyWord"
                         placeholder="请输入关键字搜索" style="margin-left:20px;width: 200px;" @change="searchFn"/>
            </div>
<!--            <div v-if="$route.path !== '/skl/declarationCenter/projectDeclaration'">-->
            <div>
                <a-button v-if="routerKey == 0 || routerKey == 1 || routerKey == 2||routerKey == 9" type="primary"
                          @click="openTable">我要申报
                </a-button>
            </div>
        </div>
        <div v-if="routerKey == 3 || routerKey == 4 || routerKey == 5" class="content">
            <div v-for="(item, index) in headerList" :key="index" class="content-box">
                <div
                    :class="checkIndex == index ? 'active' : ''"
                    class="box-item"
                    @click="chooseItem(item, index)"
                >
                    {{ item.name }}
                </div>
                <div class="border"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "commonHeader",
    data() {
        return {
            checkIndex: 1,
            chooseKey: 0,
            routerKey: 0,
            routerTitle: "",
            keyWord: "",
            selectYearValue: undefined,
            selectProvinceOpinion: undefined,
            yearList: [
                {
                    name: "全部",
                    value: "",
                },
                {
                    name: "2024",
                    value: "2024",
                },
                {
                    name: "2023",
                    value: "2023",
                },
            ],
            projectList: [
                {
                    name: "全部",
                    value: "",
                },
                {
                    name: "重点项目",
                    value: "重点项目",
                },
                {
                    name: "一般项目",
                    value: "一般项目",
                },
                {
                    name: "基地项目",
                    value: "基地项目",
                },
            ],
            headerList: [
                {
                    name: "基层单位",
                    value: 0
                },
                {
                    name: "市社科联/高校社科联",
                    value: 1
                },
                {
                    name: "省社科联",
                    value: 2
                },
            ],
        };
    },
    methods: {
        searchFn() {
            this.$emit("searchTable", this.keyWord)
        },
        chooseItem(val, i) {
            // val:  当前item的name和value对象
            console.log('---', val);
            console.log('+++', i);
            this.checkIndex = i;
            this.chooseKey = val.value;
            this.$emit("chooseTable", this.chooseKey)
        },
        openTable() {
            sessionStorage.removeItem("declareInfo");
            sessionStorage.removeItem("revewInfo");
            sessionStorage.removeItem("myRateList");
            sessionStorage.removeItem("cityRateList");
            sessionStorage.removeItem("provincialRateList");
            this.$emit("openProjectTable");
        },
        handleChange() {
            // console.log(this.selectYearValue);
            // console.log(this.selectProvinceOpinion);
            this.$emit("changeTable", this.selectYearValue);
        },
        handleOpinionChange() {
            this.$emit("changeOpinion", this.selectProvinceOpinion);
        }
    },
    created() {
        this.routerTitle = this.$route.meta.title;
        this.routerKey = this.$route.meta.chooseKey;
    },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
